import { CLOSE_AUDIO_NARRATION_PANEL, OPEN_AUDIO_NARRATION_PANEL, UPDATE_AUDIO_NARRATION_STATE } from '../actions/actionTypes';
const INITIAL_STATE = {
  isPanelOpen: false,
  hasFetchedTranscript: false
};
export default function audioNarration(state = INITIAL_STATE, action) {
  switch (action.type) {
    case OPEN_AUDIO_NARRATION_PANEL:
      return Object.assign({}, state, {
        openedVia: action.openedVia,
        isPanelOpen: true
      });
    case CLOSE_AUDIO_NARRATION_PANEL:
      return Object.assign({}, state, {
        audioUrl: null,
        isPanelOpen: false
      });
    case UPDATE_AUDIO_NARRATION_STATE:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}